module.exports = __webpack_public_path__ + "static/media/eminence-ikebukuro-7.4828dc9f.jpg";